import $ from '../libraries/jquery';
import twbsPagination from '../libraries/jquery.twbsPagination';

export default function () {
    const $pagination = $('#pagination');

    if (!$pagination.length) {
        return;
    }

    twbsPagination();

    const totalPages = parseInt($pagination.data('totalpages'), 10) || 1;
    const currentPage = parseInt($pagination.data('currentpage'), 10) || 1;

    $pagination.twbsPagination({
        first: '&laquo;',
        prev: '&lsaquo;',
        next: '&rsaquo;',
        last: '&raquo;',
        startPage: currentPage,
        totalPages: totalPages,
        visiblePages: 5,
        initiateStartPageClick: false,
        onPageClick: (evt, page) => {
            const url = new URL(window.location.href);
            url.searchParams.set('page', page);
            window.location.href = url.toString();
        }
    });
}
